import { colors } from './globals'

export const button = `button {
  font-size: 12px;
  font-weight: bold;
  color: white;
  margin-top: 5px;
  padding: 7px 10px 7px 10px;
  border-radius: 5px;
  border: 0;
  font-style: bold;
  background-color: ${colors.darkBlue}
}`
